import React from 'react';
import { IoClose } from 'react-icons/io5';

/** Shared dismiss control for dialogs, popovers, drawers, and detail panels. */
const CloseButton = ({
  onClick,
  label = 'Close',
  title = 'Close',
  disabled = false,
  variant = 'dark',
  className = '',
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={title}
    className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${variant === 'light' ? 'border-slate-200 bg-white text-slate-500 hover:bg-slate-100 hover:text-slate-900 focus-visible:ring-offset-white' : 'border-white/10 bg-white/[0.04] text-slate-300 hover:bg-white/[0.1] hover:text-white focus-visible:ring-offset-slate-900'} ${className}`}
  >
    <IoClose className="h-5 w-5" aria-hidden="true" />
  </button>
);

export default CloseButton;
